"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const event_fragment_1 = __importDefault(require("../fragments/event.fragment"));
const query = (0, client_1.gql) `
  query eventGuestList($eventId: String!) {
    event(eventId: $eventId) {
      _id
      name
      cancel
      venue {
        _id
        name
        address {
          timezone
        }
      }
      schedule {
        startsAt
        endsAt
      }
      performances {
        _id
        schedule {
          doorsAt
          startsAt
          endsAt
        }
      }
      ...EventGuestList
    }
  }

  ${event_fragment_1.default.fragments.guestList}
`;
exports.default = query;
//# sourceMappingURL=eventGuestList.query.js.map